import React from "react";
import ReactModal from "react-modal";

interface BottomSheetProps {
  visible: boolean;
  title?: string;
  children: React.ReactNode;
  onDismiss: () => void;
  onRightAction?: () => void;
  rightActionLabel?: string;
  shouldCloseOnOverlayClick?: boolean;
}

ReactModal.setAppElement("#apps");

export const BottomSheet: React.FunctionComponent<BottomSheetProps> = ({
  visible,
  onDismiss,
  title,
  children,
  onRightAction,
  rightActionLabel,
  shouldCloseOnOverlayClick = true,
}) => {
  return (
    <ReactModal
      isOpen={visible}
      className="bg-custombg bottom-0 flex flex-col w-full mx-auto max-w-screen-mobile rounded-t-2xl outline-none border border-1 border-b-0 z-[60]"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-end z-[100]"
      onRequestClose={onDismiss}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      style={{
        content: {
          animation: "0.2s ease-in-out slideUp",
        },
      }}
    >
      <div className="p-4">
        <div className="flex flex-row">
          {title && <p>{title}</p>}
          {onRightAction && rightActionLabel && (
            <p className="cursor-pointer" onClick={onRightAction}>
              {rightActionLabel}
            </p>
          )}
        </div>
        <div className="flex-col">{children}</div>
      </div>
    </ReactModal>
  );
};
